<template>
    <q-modal v-model="show_event" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}">
        <q-modal-layout v-if="!event">
            <div>No event</div>
        </q-modal-layout>
        <q-modal-layout v-else>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="show_event = false" icon="fas fa-times" />
                <q-toolbar-title>
                    {{ $t('event') }} - {{ event.first_event_date }}
                </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding">
                <div class="row gutter-sm justify-end question-list">
                    {{ 'EVENT!' }}
                    <!-- <q-btn color="secondary" v-if='reportsPermission' class="q-mr-sm" icon="fas fa-download" :label="$t('tests_report')" @click="downloadReportModel()" /> -->
                    <!-- <div class="col-xs-12 col-sm-12" v-for="(question, index) in test_results" :key="index">

                        <span :class="getQuestionClass(index, question)">
                            {{ index + 1 }}) <span v-html="question.question"></span>
                        </span>

                        <q-field :error="question.error">
                            <q-option-group
                                type="radio"
                                v-model="question.answer_correct_id"
                                :options="question.answers"
                                class="questions q-mt-xs"
                                @input="question.error = false"
                                readonly
                            />
                        </q-field>
                    </div> -->
                </div>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'AdminPresentialReportEvent',

    props: ['show_event_report', 'event'],

    data() {
        return {
            loading: false,
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
        }),

        show_event: {
            get() {
                return this.show_event_report
            },
            set() {
                this.$emit('hide_event_report', '')
            }
        },

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        name() {

        }
    },
}
</script>

<style>

</style>
